/**
 * 个人中心子路由：刷新/分享链接时保留当前面板（basic/orders/invoice/title）
 */
import clientPersonalCenter from './index.vue';
import PersonalCenterMain from './layout/Main.vue';
import PcBasicInfo from './panels/BasicInfo/index.vue';
import PcMyOrders from './panels/MyOrders/index.vue';
import PcInvoiceCenter from './panels/InvoiceCenter/index.vue';
import PcTitleManage from './panels/TitleManage/index.vue';

/** 个人中心根路径 */
export const PERSONAL_CENTER_BASE = '/client/personal-center';

/** 个人中心默认页（基本信息） */
export const PERSONAL_CENTER_HOME = `${PERSONAL_CENTER_BASE}/basic`;

/** 菜单 key -> 子路由 path */
export function personalCenterMenuPath(menuKey) {
  return `${PERSONAL_CENTER_BASE}/${menuKey}`;
}

export const personalCenterRoute = {
  path: PERSONAL_CENTER_BASE,
  name: 'clientPersonalCenter',
  component: clientPersonalCenter,
  children: [
    {
      path: '',
      component: PersonalCenterMain,
      // 仅匹配 /client/personal-center 时默认进入 basic，避免右侧面板空白
      redirect: (to) => ({
        name: 'clientPersonalCenterBasic',
        query: to.query,
      }),
      children: [
        {
          path: 'basic',
          name: 'clientPersonalCenterBasic',
          component: PcBasicInfo,
          meta: { menuKey: 'basic' },
        },
        {
          path: 'orders',
          name: 'clientPersonalCenterOrders',
          component: PcMyOrders,
          meta: { menuKey: 'orders' },
        },
        {
          path: 'invoice',
          name: 'clientPersonalCenterInvoice',
          component: PcInvoiceCenter,
          meta: { menuKey: 'invoice' },
        },
        {
          path: 'title',
          name: 'clientPersonalCenterTitle',
          component: PcTitleManage,
          meta: { menuKey: 'title' },
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/view/client/personal-center/routes.js